import { DISCLAIMER, VERSION } from '../../../configuration/genovAiConfig';

import styles from './footer.module.scss';


const FooterComponent: React.FC = () => {

    return (
        <div className={styles.container}>
            <div className={styles.disclaimerComponent}>
                {DISCLAIMER}
            </div>
            {/* <div className={styles.versionComponent}>
                {VERSION}
            </div> */}
        </div>
    )
}

export { FooterComponent }


